import { t } from '@lingui/core/macro';

import { SkeletonRectangle } from '@/components/loaders';
import { Progress } from '@/components/Progress';
import { Text } from '@/components/typography';

type Props = {
  isLoading: boolean;
  value?: number;
};

const OnboardingProgressBar = ({ isLoading, value }: Props) => {
  value = isLoading || !value ? 0 : Math.floor(value * 100) / 100;
  const valuePercentNumber = Math.floor(value * 100);

  if (isLoading) {
    return <SkeletonRectangle width={144} height={144} className="shrink-0 rounded-full" />;
  }

  return (
    <Progress
      value={valuePercentNumber}
      aria-label={t`Onboarding Progress`}
      className="relative size-36 shrink-0 items-center justify-center"
    >
      <svg viewBox="0 0 120 120" className="size-36 -rotate-90" aria-hidden="true">
        <circle cx="60" cy="60" r="50" strokeWidth="10" className="fill-none stroke-gray-200" />
        {valuePercentNumber > 0 && (
          <circle
            cx="60"
            cy="60"
            r="50"
            pathLength="100"
            strokeWidth="10"
            strokeLinecap="round"
            strokeDasharray="100"
            strokeDashoffset={100 - valuePercentNumber}
            className="fill-none stroke-green-400"
          />
        )}
      </svg>
      <Text variant="kpi" weight="bold" className="absolute">
        {valuePercentNumber}%
      </Text>
    </Progress>
  );
};

export default OnboardingProgressBar;
